/**
 * 69.36 (lane F's 69.33 integration pass: the tank's turret read the bullet gun's line, and named neither X nor V): the
 * seated help lines of a tank's two fighting seats, each naming its own weapon and keys. Plain text from the seat's state;
 * the host's updateHelp shows it (src/game/actionHost.ts).
 */
import type { SeatState, TankRound } from '../types';

const ROUND: Record<TankRound, string> = { he: 'HE', solid: 'SOLID' };

/**
 * The turret's gunner (TANK.turretSeat): the mouse lays the turret, a click fires the main gun — the round in it, else
 * loading or empty — X the round loaded next (69.51: with one in the breech, a swap to the other kind), right mouse the coax, R reloads the coax's belt (the main gun reloads by
 * itself), V the gunner's sight, E out. (The seat switch, DECISIONS 250, the host's tail names: it knows the other seat.)
 */
export function tankGunnerHelp(main: NonNullable<SeatState['main']>, next: TankRound, sightOn: boolean): string {
  const gun = main.loaded ? `${ROUND[main.loaded]} loaded` : main.reloadLeft !== undefined ? 'loading' : 'empty';
  // (69.51: with a round in the breech and the other kind stowed, X swaps it — the other loaded in a reload's time)
  const other: TankRound = main.loaded === 'he' ? 'solid' : 'he';
  const x = main.loaded && main.reloadLeft === undefined && main[other] > 0 ? `X swap to ${ROUND[other]}` : `X next round: ${ROUND[next]}`;
  return `Gunner: mouse or A / D · W / S lay the turret · click the main gun (${gun}) · ${x} · right mouse the coax · R reload the coax · V ${sightOn ? 'leave the sight · Space lase (held; at ×8 the gun laid up for it) · wheel ×2 / ×4 / ×8' : 'the sight'} · E get out`;   // (413)
}

/** The commander (the cupola's .50 on its ring): the mouse lays it, a held click fires, R reloads the belt, E out (never the seat switch: 250). */
export function tankCommanderHelp(): string {
  return 'Commander: mouse lays the .50 on the cupola · hold click to fire · R reload the belt · E get out';
}
